module.exports = __webpack_public_path__ + "img/shawn.34131a51.jpg";